import useTranslation from 'next-translate/useTranslation'
import { useIsFetching } from 'react-query'

import IconFilters from '@/assets/svg/purge/icons/icon-filters.svg'
import Button from '@/atoms/Button/Button'
import { showModal } from '@/store/slices/modal'
import { Media } from '@/templates/Media/Media'

function Controls({ count = 0 }) {
  const { t } = useTranslation('products')
  const isFetching = useIsFetching()

  const openFilterBox = () => showModal('filter_box')

  return (
    <>
      {count > 0 && (
        <div className="flex items-center justify-between flex-shrink-0 w-full xl:w-auto xl:items-start xl:ml-auto xl:justify-start">
          <Media lessThan="xl">
            <Button
              className="px-2 py-1 -ml-2 space-x-2"
              icon={<IconFilters />}
              text="Filtruj"
              variant="flat"
              onClick={openFilterBox}
            />
          </Media>
          {!isFetching && (
            <span className="text-xs text-gray-75 xl:ml-auto">
              {t('results', { count })}
            </span>
          )}
        </div>
      )}
    </>
  )
}

export default Controls
